import { useState } from "react";
import { Lightbox } from "./Lightbox";
import { Maximize2 } from "lucide-react";

const GENERIC = "https://images.pexels.com/photos/5922101/pexels-photo-5922101.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900&h=900&fit=crop";

export const ProductGallery = ({ images = [], name }) => {
  const safeImages = images && images.length > 0 ? images : [GENERIC];
  const [active, setActive] = useState(0);
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-4" data-testid="product-gallery">
      <div
        className="relative aspect-square bg-neutral-50 border border-neutral-200 overflow-hidden group cursor-zoom-in"
        onClick={() => setOpen(true)}
        data-testid="gallery-main"
      >
        <img
          src={safeImages[active]}
          alt={name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = GENERIC;
          }}
        />
        <button
          className="absolute top-4 right-4 w-10 h-10 bg-white/80 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          aria-label="Open lightbox"
          data-testid="gallery-zoom"
        >
          <Maximize2 className="w-4 h-4" />
        </button>
        <div className="absolute bottom-4 left-4 text-[10px] tracking-[0.2em] uppercase bg-white px-2 py-1 font-medium border border-neutral-200">
          Authentic · Lot verified
        </div>
      </div>

      <div className="grid grid-cols-4 gap-3">
        {safeImages.map((src, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`relative aspect-square overflow-hidden border-2 transition-colors ${
              i === active ? "border-black" : "border-neutral-200 hover:border-neutral-400"
            }`}
            data-testid={`gallery-thumb-${i}`}
          >
            <img
              src={src}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src = GENERIC;
              }}
            />
          </button>
        ))}
      </div>

      <Lightbox
        images={safeImages}
        initialIndex={active}
        open={open}
        onClose={() => setOpen(false)}
      />
    </div>
  );
};
